import React, {ReactElement} from 'react';

import {BrowserRouter, Navigate, Route, Routes} from 'react-router-dom';
import {isIE} from 'react-device-detect';

import {Provider} from "react-redux";
import {store} from "./lib/redux/store";
import {initFsCockpitAxiosBindings} from "./lib/api/axiosFsCockpitAuthAdapter";
import {RequireAuth} from "features/auth/RequireAuth";
import {LoginPage} from "features/auth/LoginPage";
import {TranslationProvider} from "./features/i18n/TranslationProvider";
import {MenuSection} from 'features/menu/MenuSection';
import {ChoseCustomerPage} from "./features/auth/ChoseCustomerPage";
import { DevInit } from 'DevInit';

initFsCockpitAxiosBindings(store);


export default function App(): ReactElement {
  if (isIE) return (
    // TODO: Translate this string...
    <div>
      <h1>Please use another Browser...</h1>
      <p>Sie benutzen einen veralteten Browser. Damit wir ein sicheres und benutzerfreundliches Benutzererlebnis geben können, benutzen Sie bitte einen modernen Browser wie: Chrome, Firefox, Safari, Opera, oder Edge.</p>
    </div>
  );

  return (
      <Provider store={store}>
        <TranslationProvider>
          <BrowserRouter>
            {process.env.NODE_ENV==="development"&&<DevInit/>}
            <div className="App">
              <Routes>
                <Route path="/" element={<Navigate to="/menus" />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/login/customer" element={<ChoseCustomerPage />} />
                <Route path="/*" element={
                    <RequireAuth>
                        <Routes>
                            <Route path="/menus/*" element={<MenuSection />} />
                        </Routes>
                    </RequireAuth>
                } />
              </Routes>
            </div>
          </BrowserRouter>
        </TranslationProvider>
      </Provider>
  );
}
